import {
	useIsSiteAdmin as useIsVortexOrgAdminOrNonVortexSiteAdmin,
	useIsAdmin as useIsJiraAdmin,
} from './useCanEditIssues.tsx';
import { useHasPermissions, type UseHasPermissionsPayload } from './useHasPermissions.tsx';

type UseHasPermissionsWithSiteAdminPayload = UseHasPermissionsPayload & {
	/**
	 * Returns true if the user is a site admin.
	 * Regardeles whether the user has the permission keys or not.
	 *
	 * @default false
	 */
	allowedForSiteAdmin?: boolean;
};

export const useHasPermissionsWithSiteAdmin = ({
	allowedForSiteAdmin = false,
	...payload
}: UseHasPermissionsWithSiteAdminPayload): boolean => {
	const hasPermissions = useHasPermissions(payload);
	const isJiraAdmin = useIsJiraAdmin();
	const isVortexOrgAdminOrNonVortexSiteAdmin = useIsVortexOrgAdminOrNonVortexSiteAdmin();

	return allowedForSiteAdmin
		? isJiraAdmin || isVortexOrgAdminOrNonVortexSiteAdmin || hasPermissions
		: hasPermissions;
};
